module.exports = __webpack_public_path__ + "assets/icon-production.b8502563.svg";